import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from '../../../state/language/language.service';
import { languages } from '../../../state/language/languages';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.css',
})
export class LanguageSelectorComponent {
  private languageService = inject(LanguageService);

  protected languages = languages;
  protected currentLocale = this.languageService.getCurrentLocale();

  public changeLanguage(event: Event) {
    const target = event.target as HTMLSelectElement;
    if (target?.value) {
      this.languageService.setLanguage(target.value);
    }
  }
}
